import React from 'react'
import { useCallback, useMemo, useMedia } from 'sb-hooks'
import { constants, mixpanel } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Title from 'components/_new/typography/deprecated/Title/Title'
import UpgradePlans from 'components/upgradePlans/UpgradePlans/UpgradePlans'
import ContentWithLoader from 'components/loaders/ContentWithLoader/ContentWithLoader'
import { WidthContainer } from 'components/_new/layout/widthContainer'
import usePlans from 'components/upgradePlans/usePlans'

import SelectedPlanSummaryModal from '../../components/SelectedPlanSummaryModal/SelectedPlanSummaryModal'

import messages from './messages'
import s from './UpgradeSection.scss'


const UpgradeSection = ({ redirectLink }) => {
  const { isDesktop } = useMedia()

  const additionalPlans = useMemo(() => ({
    MONTHLY_2PCS: {
      discount: '-16%',
      saveValue: '$4.90',
      className: s.popularPlan,
    },
    MONTHLY: {},
  }), [])

  const sortFunction = useCallback((a, b) => (
    b.productsPerPeriod - a.productsPerPeriod
  ), [])

  const { isFetching, plans, setSelectedPlan, selectedPlan } = usePlans({
    additionalPlans, sortFunction,
  })

  const handlePlanSelect = useCallback(({ name, productsPerPeriod }) => {
    mixpanel.track(constants.analyticsEvents.newThankYouPage.upgradeOptionClick, {
      productsPerPeriod,
    })

    setSelectedPlan(name)
  }, [ setSelectedPlan ])

  return (
    <div>
      <Box className={s.container} mb="36" pb="16" relative>
        <WidthContainer>
          <Box className={s.titles} pt={isDesktop ? '96' : '36'} center>
            <Title size="xlg" message={messages.title} />
            <Box mt="24">
              <Text message={messages.subTitle} size="16-24" />
            </Box>
          </Box>
          {
            isDesktop && (
              <Box className={s.hintContainer} mt="96" alignCenter relative center>
                <Text message={messages.hint} size="28-40" color="white" semibold />
              </Box>
            )
          }
        </WidthContainer>
      </Box>
      <WidthContainer>
        <div className={s.plans}>
          <ContentWithLoader isFetching={isFetching}>
            <UpgradePlans
              className={s.plansContainer}
              plans={plans}
              onPlanSelect={handlePlanSelect}
            />
          </ContentWithLoader>
        </div>
      </WidthContainer>
      {
        Boolean(selectedPlan) && (
          <SelectedPlanSummaryModal
            plan={selectedPlan}
            onClose={() => setSelectedPlan(null)}
            redirectLink={redirectLink}
          />
        )
      }
    </div>
  )
}


export default UpgradeSection
